module.exports = __webpack_public_path__ + "fonts/fa-brands-400.5795bc0a.woff2";